import React from 'react';

import '@/components/badges/BadgeStyles.css';
import { LTTooltip } from '@/components/ui/LTTooltip';

type OperationalType = 'stalled' | 'drifted' | 'blocked' | 'active';
type Severity = 'low' | 'medium' | 'high';

const STYLE: Record<OperationalType, string> = {
  stalled: 'lt-badge--stalled',
  drifted: 'lt-badge--drifted',
  blocked: 'lt-badge--blocked',
  active: 'lt-badge--active',
};

const LABEL: Record<OperationalType, string> = {
  stalled: 'Stalled',
  drifted: 'Drifted',
  blocked: 'Blocked',
  active: 'Active Focus',
};

const ICON: Record<OperationalType, string> = {
  stalled: '🔥',
  drifted: '⚠️',
  blocked: '⏳',
  active: '⚡',
};

const TOOLTIP: Record<OperationalType, string> = {
  stalled: '🔥 Stalled (Heat): Delegated for more than 48 hours with zero action.',
  drifted: '⚠ Drifted (Collision): The master plan changed, and this branch is now out of alignment with the root goal.',
  blocked: '⏳ Blocked: A task cannot move because an input (←) or upstream (↑) dependency is missing.',
  active: '⚡ Active Focus: Presence badge showing who is currently inside the node editing the plan.',
};

export function OperationalBadge({ type, severity }: { type: OperationalType; severity?: Severity }) {
  const sevClass =
    severity === 'high'
      ? 'lt-badge--sev-high'
      : severity === 'medium'
        ? 'lt-badge--sev-med'
        : severity === 'low'
          ? 'lt-badge--sev-low'
          : '';
  return (
    <LTTooltip content={TOOLTIP[type] || LABEL[type] || type}>
      <span className={`lt-badge ${STYLE[type]} ${sevClass}`} tabIndex={0}>
        <span className="lt-badge__icon" aria-hidden>
          {ICON[type] || '🏷️'}
        </span>
        <span>{LABEL[type] || type}</span>
      </span>
    </LTTooltip>
  );
}

